var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGraph = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15487 0H10.5674C10.7968 0 11.0262 0.249166 10.9976 0.498331V4.20467C10.9976 4.85873 10.2806 5.20133 9.85049 4.73415L8.90416 3.70634L6.15118 6.69633C5.80706 7.10122 5.20484 7.10122 4.86072 6.69633L2.76731 4.42269L1.4195 5.85539C1.24744 6.04227 0.960674 6.04227 0.788613 5.85539L0.129046 5.13904C-0.0430152 4.95217 -0.0430152 4.64071 0.129046 4.45384L2.10775 2.30478C2.45187 1.89989 3.05408 1.89989 3.3982 2.30478L5.52029 4.57842L7.6137 2.30478L6.66736 1.27697C6.23721 0.809789 6.55266 0 7.15487 0Z",
    fill: "#00A8E1"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGraph, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/graph.ca4a25e2.svg";
export { ForwardRef as ReactComponent };